import { render } from "./EditLock.vue?vue&type=template&id=256c83d0&scoped=true"
import script from "./EditLock.vue?vue&type=script&lang=js"
export * from "./EditLock.vue?vue&type=script&lang=js"

import "./EditLock.vue?vue&type=style&index=0&id=256c83d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256c83d0"]])

export default __exports__